import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import { Button } from "@material-ui/core";
import SearchIcon from "@mui/icons-material/Search";
import InputAdornment from "@material-ui/core/InputAdornment";
import Table from "@material-ui/core/Table";
import TableBody from "@material-ui/core/TableBody";
import TableCell from "@material-ui/core/TableCell";
import TableContainer from "@material-ui/core/TableContainer";
import TableHead from "@material-ui/core/TableHead";
import TableRow from "@material-ui/core/TableRow";
import Paper from "@material-ui/core/Paper";
import Container from "@material-ui/core/Container";
import {
  getUserGroupById,
  UpdateUserGroupAccess,
} from "../../../service/endpoint-manager";
import Loading from "../Shared/Loading";
import Checkbox from "@mui/material/Checkbox";

import MenuItem from "@mui/material/MenuItem";

import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import clsx from "clsx";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogContentText from "@material-ui/core/DialogContentText";
import DialogTitle from "@material-ui/core/DialogTitle";
import { APP_FUNCTIONS } from "../../../types/micellinous-constants";
import { useSnackbar } from "notistack";
import ShieldIcon from "@mui/icons-material/Shield";
import Tooltip from "@material-ui/core/Tooltip";

import styles from "../../../styles.module.css";

import { UserGroupRoleTable } from "@thequantumhub/iam-package";

var userGroupOptions = [];
const appFunctions = APP_FUNCTIONS();
const Roles = ({
  userGroupId,
  userGroups,

  setUserGroupId,
  setSelectedUserGroup,
  ...rest
}) => {
  const useStyles = makeStyles((theme) => ({
    userAccessStyles: {
      fontFamily: "poppins, sans-serif",
    },
    componentHeadingStyles: {
      textTransform: "uppercase",
    },

    search: {
      display: "flex",
      justifyContent: "space-between",
      alignItems: "center",
      marginBottom: "1rem",
    },

    searchLeft: {
      width: "60%",
      display: "flex",
      alignItems: "center",
      [theme.breakpoints.down("md")]: {
        flexDirection: "column",
        width: "100%",
      },
    },

    searchRight: {
      width: "40%",
      display: "flex",
      justifyContent: "flex-end",
    },

    searchBoxStyles: {
      width: "12rem",
      borderTopRightRadius: "0",
      borderBottomRightRadius: "0",
      marginLeft: "8%",
      marginRight: "5%",
      backgroundColor: "#f7f7f7",
    },

    dropdown: {
      borderTopRightRadius: "0",
      borderBottomRightRadius: "0",
      marginLeft: "8%",
      marginRight: "5%",
      backgroundColor: "#f7f7f7",
      height: "2.5rem",
      width: "10rem",
    },

    btnStyles: {
      background: "#1B2132",
      color: "#fff",
      padding: "0.5rem",
    },

    addUserGroupBtn: {
      background: "#1B2132",
      color: "#fff",
    },

    searchIcon: { position: "absolute", right: 0 },

    label: {
      fontSize: "0.875rem",
      [theme.breakpoints.down("md")]: {
        width: "30%",
      },
    },

    labelFunction: { display: "flex", alignItems: "center", marginLeft: "4%" },

    column: { fontWeight: "700" },

    checkbox: { width: "1.3rem", color: "#000 !important" },

    tableHead: { backgroundColor: "#f7f7f7" },

    table: {},

    rolesContainer: { padding: 0 },

    menuItems: {
      display: "block",
      paddingRight: "15px",
      paddingLeft: "15px",
      marginTop: "5px",
      marginBottom: "5px",
    },

    saveBtnStyles: {
      width: "10rem",
    },

    cta: {
      display: "flex",
      justifyContent: "flex-end",
    },

    tableContainer: {
      margin: "1rem 0",
    },

    dialogStyles: {
      "& .MuiPaper-root": {
        width: "100%",
        maxWidth: "400px",
        borderRadius: "20px",
        paddingBottom: "1.25rem",
      },
    },

    dialogActionStyles: {
      display: "flex",
      justifyContent: "space-between",
      margin: "auto 1rem",
    },

    dialogDeleteBtnStyles: {
      "&:hover": {
        background: "#ff0000",
      },
    },

    dialogCancelBtn: {
      background: "#8a8a8a",
    },

    userGroupSelectorStyles: {
      display: "flex",
      alignItems: "center",
      padding: "0 1rem",
      marginRight: "0.5rem",
      [theme.breakpoints.down("md")]: {
        marginRight: "0",
      },
    },

    appFunctionSelectorStyles: {
      display: "flex",
      alignItems: "center",
      padding: "0 1rem",
    },
  }));

  const [loading, setLoading] = useState(false);
  const [userGroup, setUserGroup] = useState(false);
  const [appFunction, setAppFunction] = useState(appFunctions[0]);
  const [appSubfunctions, setAppSubfunctions] = useState({});

  const [initialValues, setInitialValues] = useState({});
  const [openSaveUserGroupUpdatesDialog, setopenSaveUserGroupUpdatesDialog] =
    React.useState(false);
  const { enqueueSnackbar } = useSnackbar();

  const handleUserGroupSelection = (e) => {
    setUserGroupId(e.target.value);
    setAppFunction(appFunctions[0]);
  };

  const handleFunctionSelect = (e) => {
    setAppFunction(e.target.value);
  };

  // method to handle closing addUserGroup dialog
  const handleCloseSaveUserGroupUpdatesDialog = () => {
    setopenSaveUserGroupUpdatesDialog(false);
  };

  const handleUpdateUserGroupAccess = async () => {
    const updatedUserGroup = { ...userGroup };
    updatedUserGroup["dashboard"] = initialValues;
    setUserGroup(updatedUserGroup);

    const result = await UpdateUserGroupAccess(updatedUserGroup);

    if (result?.data?.status === true) {
      enqueueSnackbar(`${result?.data?.message}`, {
        variant: "success",
      });
    } else {
      enqueueSnackbar(`${result?.data?.message}`, {
        variant: "error",
      });
    }

    // close the dialog box after response shown to user
    setopenSaveUserGroupUpdatesDialog(false);
  };

  useEffect(() => {
    userGroupOptions = [];

    userGroups.map((userGroup) => {
      if (userGroup.template !== true) {
        userGroupOptions.push({
          id: userGroup.ID,
          value: userGroup.name,
          label: userGroup.name,
          isAdmin: userGroup.isAdmin,
        });
      }
    });
  }, []);

  useEffect(() => {
    const getUserGroup = async () => {
      setLoading(true);
      const result = await getUserGroupById(userGroupId);
      if (result?.status === 200) {
        setUserGroup(result.data.body);
        setAppSubfunctions(result.data.body.dashboard);
        setInitialValues(result.data.body.dashboard);
        setSelectedUserGroup(result.data.body);
      }
      setLoading(false);
    };

    getUserGroup();
  }, [userGroupId]);

  useEffect(() => {
    setAppSubfunctions(userGroup[appFunction]);
    setInitialValues(userGroup[appFunction]);
  }, [appFunction]);

  /*
   * handles checkbox toggling when clicked to form payload to send to updateUserGroupAccess API -
   * seemingly simple task but not that simple ;)
   *
   * Author: Sohaib Furqan
   */
  const handleChangeSelection = (appSubfunctions, mainFunction, action) => {
    const updatedValues = { ...initialValues };
    updatedValues[mainFunction][action] = !updatedValues[mainFunction][action];
    setInitialValues(updatedValues);
  };

  const classes = useStyles();

  if (loading) {
    return <Loading />;
  }

  return (
    <Container width="sm" className={classes.rolesContainer}>
      <section className={classes.userAccessStyles}>
        <section className={classes.search}>
          <div className={classes.searchLeft}>
            <section className={classes.userGroupSelectorStyles}>
              <label className={classes.label}>UserGroup</label>
              <FormControl sx={{ m: 1, minWidth: 120 }}>
                <Select
                  option={userGroupOptions}
                  defaultValue={userGroupId}
                  onChange={(e) => {
                    handleUserGroupSelection(e);
                  }}
                  className={classes.dropdown}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment className={classes.searchIcon}>
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                >
                  {userGroupOptions?.map((userGroup, index) => (
                    <MenuItem
                      key={userGroup?.id}
                      value={userGroup?.id}
                      className={classes.menuItems}
                    >
                      {userGroup?.value}

                      {userGroup?.isAdmin && (
                        <Tooltip
                          arrow
                          title="Admin Access"
                          placement="top-start"
                        >
                          <ShieldIcon style={{ width: "1rem" }} />
                        </Tooltip>
                      )}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </section>

            <section className={classes.appFunctionSelectorStyles}>
              <label className={classes.label}>App Function</label>
              <FormControl sx={{ m: 1, minWidth: 120 }}>
                <Select
                  value={appFunction}
                  onChange={(e) => {
                    handleFunctionSelect(e);
                  }}
                  className={classes.dropdown}
                  displayEmpty
                  inputProps={{ "aria-label": "Without label" }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment className={classes.searchIcon}>
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                >
                  {appFunctions?.map((functionName, index) => (
                    <MenuItem
                      key={index}
                      value={functionName}
                      className={classes.menuItems}
                    >
                      {functionName}
                    </MenuItem>
                  ))}
                </Select>
              </FormControl>
            </section>
          </div>
        </section>

        {/* table */}
        <UserGroupRoleTable
          appSubfunctions={appSubfunctions}
          userGroup={userGroup}
          handleChangeSelection={handleChangeSelection}
        />

        <section className={classes.cta}>
          <Button
            variant="contained"
            className={styles.primaryButton}
            onClick={() => {
              setopenSaveUserGroupUpdatesDialog(true);
            }}
          >
            Save
          </Button>
        </section>

        {/* Delete User Group Dialog - opens when 'Delete' button is clicked next to each usergroup entry in the table*/}
        <Dialog
          open={openSaveUserGroupUpdatesDialog}
          onClose={handleCloseSaveUserGroupUpdatesDialog}
          maxWidth="lg"
          className={classes.dialogStyles}
        >
          <DialogTitle id="add-userGroup-dialog">Confirm Action</DialogTitle>
          <DialogContent>
            <DialogContentText>
              Are you sure you want to save changes?
            </DialogContentText>
          </DialogContent>
          <DialogActions className={classes.dialogActionStyles}>
            <Button
              onClick={handleCloseSaveUserGroupUpdatesDialog}
              color="primary"
              className={clsx(classes.btnStyles, classes.dialogCancelBtn)}
              variant="contained"
            >
              Cancel
            </Button>
            <Button
              onClick={handleUpdateUserGroupAccess}
              color="primary"
              className={clsx(classes.btnStyles, classes.dialogDeleteBtnStyles)}
              variant="contained"
            >
              Save
            </Button>
          </DialogActions>
        </Dialog>
      </section>
    </Container>
  );
};

export default Roles;
